export { default } from './Rating';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/Rating/index.js
// module id = 886
// module chunks = 2